export const SIDEBAR_DETAIL_KEYS = {
  COURSE_NUMBER: 'course-number',
  START_DATE: 'start-date',
  END_DATE: 'end-date',
  EFFORT: 'effort',
  REQUIREMENTS: 'requirements',
} as const;
